import { StripePaymentFormDeferred } from '@app/components';
import Logo from '@app/assets/horizontal-logo.svg?react';
import { useNavigate } from 'react-router-dom';
import { usePaymentPage } from './Payment.hooks.ts';
import {SubscriptionType} from "@app/utils/consts.tsx";

export const Payment = () => {
  const navigate = useNavigate();
  const { selectedPlan, selectedPlanType, planDetails, handleStripeSuccess, isProcessing, isLoading } = usePaymentPage();

  if (isLoading || !selectedPlan || !planDetails) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-baseBlue mx-auto mb-4"></div>
          <p className="text-base-coolGray">Loading payment form...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center flex-col min-h-screen py-6 bg-gray-50">
      <Logo width={139} height={110} className="mb-auto" />

      <div className="bg-white rounded-lg p-8 max-w-lg w-full mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Add Your Payment Method</h2>
          <p className="text-sm text-brand-baseBlue font-medium">{planDetails.name}</p>
          <p className="text-3xl font-bold text-gray-900">
            {planDetails.price} <span className="text-gray-500 text-lg">/monthly</span>
          </p>
          <p className="text-sm text-gray-500">{selectedPlanType == SubscriptionType.PRO ? 'First 14 days free' : 'First 5 days free'}</p>
        </div>

        <StripePaymentFormDeferred onSuccess={handleStripeSuccess} onCancel={() => navigate(-1)} submitLabel="Start Free Trial & Add Card" isLoading={isProcessing} />
      </div>

      <p className="mt-auto text-base-coolGray">
        Have an account?{' '}
        <button onClick={() => navigate('/login')} className="text-brand-baseBlue hover:underline">
          Log In
        </button>
      </p>
    </div>
  );
};
